import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';

export const checklistItemPropType = PT.shape({
  id: PT.number,
  serial: PT.number,
  sort_order: PT.number,
  description: PT.string,
  is_hyperlinked: PT.bool,
});

export const checklistImageAnnotationPropType = IPT.mapContains({
  x: PT.number,
  y: PT.number,
  type: PT.oneOf(['RECTANGLE']),
  width: PT.number,
  height: PT.number,
});
